import { PossibleBigNumber } from '@ui/types/utility';

import { createRule } from '../createValidationRunner';

export const zeroInput = createRule({
  name: 'zero_input',
  validator: ({ input }: { input: PossibleBigNumber }) => {
    if (!input) {
      return {};
    }
    if (input.lte(0)) {
      return {
        error: 'zero_input' as const,
      };
    }

    return {};
  },
});
